import script from "./FAQ.vue?vue&type=script&setup=true&lang=js"
export * from "./FAQ.vue?vue&type=script&setup=true&lang=js"

import "./FAQ.vue?vue&type=style&index=0&id=780e1a84&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-780e1a84"]])

export default __exports__